import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';

export const useQuery = () => {
  const { push, location } = useHistory();

  const query = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const setQuery = (name, { value, remove }) => {
    if (remove) {
      query.delete(name);
    } else {
      query.set(name, value);
    }

    push({
      pathname: location.pathname,
      search: query.toString(),
    });
  };

  return { query, setQuery };
};
